import { GenericTestRouteState } from './generic-test-state'

export const SocialTestRouteState = GenericTestRouteState.named(
  'SocialTestRouteState'
)
